import { NotificationTypes, NotificationTypeSoundMapper } from 'src/utils/notify'

export const soundNotification = (type: NotificationTypes): void => {
    const audio: HTMLAudioElement = new Audio(NotificationTypeSoundMapper[type])
    audio.play().then()
}
